module.exports = __webpack_public_path__ + "74c45df12464599c9b396ff92691bac5.png";